/*
  KABO ClearView reviews — manually moderated data.
  Keep customer contact/order data out of this file. Only publish content that has
  been reviewed and has explicit publication consent.
*/
(() => {
  const reviews = [
    {
      id: 'aliexpress-2026-09-09-01',
      rating: 5,
      author: 'Anonym',
      text: 'Schnelle Lieferung. Das Gerät funktioniert sehr gut. Das Wasser wird gründlich von den Fenstern abgesaugt.',
      external: true,
      source: 'aliexpress'
    }
  ];


  const displayAuthor = (value) => {
    const name = (value || '').trim();
    return !name || /^(anonym(?:ous)?|aliexpress[\s-]*(?:einkäufer|käufer|buyer|shopper|user))$/i.test(name) ? 'Anonym' : name;
  };

  const normalizeReviewDisplay = (section) => {
    section.querySelectorAll('.cv-review').forEach((card) => {
      const author = card.querySelector('figcaption span:not(.cv-review__avatar)');
      if (author) {
        const name = displayAuthor(author.textContent);
        author.textContent = name;
        const avatar = card.querySelector('.cv-review__avatar');
        if (avatar) avatar.textContent = name.charAt(0).toUpperCase();
      }
    });
    const sourceLabels = [...section.querySelectorAll('.cv-review__source')];
    const notes = [...section.querySelectorAll('[data-cv-review-origin-note]')];
    if (!sourceLabels.length && !notes.length) return;
    sourceLabels.forEach((label) => { label.hidden = true; });
    let note = notes.shift();
    notes.forEach((duplicate) => duplicate.remove());
    if (!note) {
      note = document.createElement('p');
      note.className = 'cv-reviews__origin-note';
      note.dataset.cvReviewOriginNote = 'true';
      section.querySelector('.cv-reviews__grid')?.insertAdjacentElement('afterend', note);
    }
    note.textContent = 'Einzelne Bewertungen können aus externen Produktbewertungen stammen.';
  };

  const previewMode = Boolean(window.Shopify?.designMode)
    || new URLSearchParams(window.location.search).get('kabo_review_test') === '1';
  const visibleReviews = reviews.filter((review) => !review.test || previewMode);

  const addSummaryStyles = () => {
    if (document.querySelector('[data-cv-review-summary-styles]')) return;
    const style = document.createElement('style');
    style.dataset.cvReviewSummaryStyles = 'true';
    style.textContent = `
      .cv .cv-review-summary{display:inline-flex;align-items:center;gap:9px;margin:0 0 16px;color:var(--cv-muted);font-size:11px;line-height:1.4;text-decoration:none}
      .cv .cv-review-summary:hover .cv-review-summary__count{text-decoration:underline;text-underline-offset:4px}
      .cv .cv-review-summary__stars{display:inline-flex;gap:2px;color:#6d8234;font-size:14px;letter-spacing:.02em;line-height:1}
      .cv .cv-review-summary__score{font-weight:700;color:var(--cv-ink)}
      .cv .cv-review-summary__count{color:var(--cv-muted)}
      .cv .cv-reviews__origin-note{margin:14px 0 0;color:var(--cv-muted);font-size:11px;line-height:1.55}
      @media(max-width:849px){.cv .cv-review-summary{min-height:30px;margin-bottom:12px}.cv .cv-reviews__origin-note{font-size:10px}}
    `;
    document.head.appendChild(style);
  };

  const renderSummary = (page) => {
    if (!visibleReviews.length || page.querySelector('[data-cv-review-summary]')) return;
    const purchase = page.querySelector('.cv-purchase');
    const title = purchase?.querySelector('h1');
    if (!purchase || !title) return;

    const count = visibleReviews.length;
    const average = visibleReviews.reduce((sum, review) => sum + Number(review.rating || 0), 0) / count;
    const averageLabel = average.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

    const summary = document.createElement('a');
    summary.className = 'cv-review-summary';
    summary.href = '#cv-reviews';
    summary.dataset.cvReviewSummary = 'true';
    summary.setAttribute('aria-label', `${averageLabel} von 5 Sternen aus ${count} ${count === 1 ? 'Bewertung' : 'Bewertungen'}`);

    const stars = document.createElement('span');
    stars.className = 'cv-review-summary__stars';
    stars.setAttribute('aria-hidden', 'true');
    stars.textContent = '★★★★★';

    const score = document.createElement('span');
    score.className = 'cv-review-summary__score';
    score.textContent = averageLabel;

    const reviewCount = document.createElement('span');
    reviewCount.className = 'cv-review-summary__count';
    reviewCount.textContent = `· ${count} ${count === 1 ? 'Bewertung' : 'Bewertungen'}`;

    summary.append(stars, score, reviewCount);
    title.insertAdjacentElement('beforebegin', summary);
  };

  const renderOriginNote = (section, grid) => {
    if (!visibleReviews.some((review) => review.external) || section.querySelector('[data-cv-review-origin-note]')) return;
    const note = document.createElement('p');
    note.className = 'cv-reviews__origin-note';
    note.dataset.cvReviewOriginNote = 'true';
    note.textContent = 'Einzelne Bewertungen können aus externen Produktbewertungen stammen.';
    grid.insertAdjacentElement('afterend', note);
  };

  const render = (page) => {
    const section = page.querySelector('#cv-reviews');
    if (!section) return;
    normalizeReviewDisplay(section);
    if (!visibleReviews.length) return;

    addSummaryStyles();
    renderSummary(page);

    let grid = section.querySelector('.cv-reviews__grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'cv-reviews__grid';
      section.querySelector('.cv-reviews__heading')?.insertAdjacentElement('afterend', grid);
    }

    section.querySelector('.cv-reviews__empty')?.setAttribute('hidden', '');

    visibleReviews.forEach((review) => {
      if (grid.querySelector(`[data-kabo-review-id="${review.id}"]`)) return;

      const card = document.createElement('figure');
      card.className = 'cv-review';
      card.dataset.kaboReviewId = review.id;

      const stars = document.createElement('div');
      stars.className = 'cv-review__stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${review.rating} von 5 Sternen`);
      for (let star = 1; star <= 5; star += 1) {
        const symbol = document.createElement('span');
        symbol.setAttribute('aria-hidden', 'true');
        symbol.textContent = '★';
        if (star > review.rating) symbol.className = 'cv-review__star-empty';
        stars.appendChild(symbol);
      }

      const quote = document.createElement('blockquote');
      const text = document.createElement('p');
      text.textContent = review.text;
      quote.appendChild(text);

      const caption = document.createElement('figcaption');
      const avatar = document.createElement('span');
      avatar.className = 'cv-review__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = displayAuthor(review.author).charAt(0).toUpperCase();
      const author = document.createElement('span');
      author.textContent = displayAuthor(review.author);
      caption.append(avatar, author);

      card.append(stars, quote, caption);
      grid.appendChild(card);
    });

    renderOriginNote(section, grid);
    normalizeReviewDisplay(section);
  };

  document.querySelectorAll('[data-cv-page]').forEach(render);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-cv-page]').forEach(render);
  });
})();
